import { render } from "./SeminarPage.vue?vue&type=template&id=5feeb14f"
import script from "./SeminarPage.vue?vue&type=script&lang=js"
export * from "./SeminarPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__